{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Add More Images"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Approve"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Back to Login"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Bill to Room"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Buy More"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Complete Purchase"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Credit or Debit Card"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "DONE"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Download"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Edit Order"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Enter"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Forgot"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Next(arrow right)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Previous(arrow left)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Zoom in/out"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Log Out"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Login"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Lookup Gallery"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "More Images"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "New Order"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Price Guide"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Print"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Process"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Purchase"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Refresh"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Remove"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Remove Prints"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Review and Purchase"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Select"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Selected Print Sizes ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Send Link"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Send Links"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Share"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Stay"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Stripe Reader"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "View Gallery"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "View My Gallery"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "View Receipt"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "You may add more images at no cost"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Apply"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Buy All Price is "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Buy all images for "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " for all"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Cart Details"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Cart Total"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Checkout"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Coupon Code"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Credit or Debit card"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Digital Image(s)"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Print"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Prints"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Buy more images to get a discount"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "This "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " will be provided free of charge."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "A link to your gallery has been sent to "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Please select image(s) to purchase before checkout"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "on "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Get "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " for "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Get all images for "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Get "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " images for "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " for "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " for "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Price Guide"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "See Price Guide for pricing"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Print"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Prints"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Purchase"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Purchased"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Purchasing"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Sorry, we experienced a problem that prevented this charge from going through. Please try again and contact us if the problem persists."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "Standard price is "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " each"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Thank you for your purchase!"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Total"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "All Digital Images"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "All Digital Images & Prints"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Unpurchased"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "View Photos"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Buy "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " and get "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " off"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " off "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " or more"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "By using Capturelife you agree to our "
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Enter and Please confirm your password."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Password Confirmation"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Contact Us"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "Email or phone"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "Email address or phone number"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Please enter an email address."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Please enter a password."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Please enter a valid email address or phone number."
    }
  ],
  "consumer_enter_valid_email_phone_": [
    {
      "type": 0,
      "value": "Please enter a valid email address or phone number."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Enter your email address or phone number to reset your password"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Forgot your Password?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Print Store"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "Generate QR Code"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Sorry, this link has expired. Please enter your email or phone number to receive another link."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Logging in..."
    }
  ],
  "consumer_logging_in_button": [
    {
      "type": 0,
      "value": "Logging in..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Let`s get back to capturing those moments!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Oops, looks like you`re missing something."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "My Personal Data"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Add Photos"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Add"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Download"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Home"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Logout"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "News"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Print Store"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Profile"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Refresh"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Share"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "Your password must be at least "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " characters."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "Your password and password confirmation don`t match."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Please take a screenshot of your QR Code or click Download button below"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Reset Password"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Resetting password..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Select All"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "To download or share an image, long tap the image to bring up your device`s share options."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Online Shop"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Terms of use"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Please enter the email and password that you would like to use."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Update password"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Update your password"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Updating password..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Welcome Back!"
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Cannot apply discount code. Purchase total is below the minimum amount required"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Discount code not found"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Please enter a real email address."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Please enter your email address."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Please fill out the fields below."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Reservation not found."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "No photos for this account. Please scan a band that was used at the photo station"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "No photos for this account. Please see a photographer or attendant"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Credit or debit card"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "Email Address"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Last Name"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "Pin"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Price (in "
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Room Number"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Secret code"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Select All"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Unlock all images"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Approval Needed"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Please request assistance"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Approve Purchase"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Enter the price for this purchase."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "You`ll be automatically logged out in "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " second"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " seconds"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Hey, still there?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digital image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digital images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " print"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " prints"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Review and Purchase"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Tap "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " to remove an image from your cart. Tap "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "COMPLETE PURCHASE"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to continue."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Add Images To Your Gallery"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Select Images To Purchase"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Tap images to add them to your gallery. Tap "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "VIEW MY GALLERY"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to return to your gallery."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Tap images to add them to your order. Tap "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "REVIEW AND PURCHASE"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to continue."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Loading images..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Select and Purchase"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "Your Image Gallery"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Select and Print"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "Your Image Gallery"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Tap image to select for purchase. Tap "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to continue."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "Your gallery is empty. Tap "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MORE IMAGES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in the upper right corner of the screen to browse available images."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Tap the print icon on an image to select it for printing. Tap the Print button to download selected images"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Tap image to select for purchase. Double tap to request a print. Tap "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to continue."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "You have unlocked all images. Tap "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " to remove from your gallery."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "You have unlocked all images. Tap an image to request a print. Tap "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " to remove from your gallery."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Add Print"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Digital purchased"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Print purchased"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Print selected"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Remove Print"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Select print"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Your Images"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Select Images"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "Your Selection"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Access Your Images"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Enter your room number, last name and email to access your gallery"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Welcome!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_clubmed": [
    {
      "type": 0,
      "value": "Enter your room number, last name and email to access your gallery"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Please enter your email address to continue."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Scan your wristband to get started"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Bill to Room"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "The total below will be billed to your room"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Complete Purchase"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Your order includes:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* All sales are final and refunds cannot be provided."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Order Details"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Tap images on the left to select for purchase."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Your cart is empty. Tap images to add them to your order."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Your cart is empty. Tap "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ADD MORE IMAGES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to add more images"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "You will receive your images by email"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Double tap image to request a print."
    }
  ],
  "kiosk_order_details_line_item_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "kiosk_order_details_line_item_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Print"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Prints"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "kiosk_order_details_line_item_unlock_all": [
    {
      "type": 0,
      "value": "All Digital Images"
    }
  ],
  "kiosk_order_details_line_item_unlock_all_prints": [
    {
      "type": 0,
      "value": "All Digital Images & Prints"
    }
  ],
  "kiosk_order_details_total": [
    {
      "type": 0,
      "value": "Total:"
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Complete Purchase"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "How would you like to complete your purchase?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Price Guide"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Buy more images to get a discount"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "Standard price is "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " per image"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "You may add more images at no cost"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Print Sizes"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Select print size(s) and count"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Processing Payment..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Discounts Offered:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Packages Offered:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " per image"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Standard Price:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Total:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Tap images to add them to your order"
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Tap images to select or unselect them for purchase. To add more images from your selection, tap "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MORE IMAGES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Reader not connected"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Reader failed to process"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Reader on standby..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Purchase Complete"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "A link to your gallery has been sent to "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Do you want to remove this image from your order? You'll need to find it again by tapping "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ADD MORE IMAGES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Room "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Rooms "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "A link has been emailed to "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Aspect Ratio"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Selected Prints"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Moment"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Count"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Complete Purchase"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Enter Payment Info"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Welcome, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Welcome, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}